import {Component} from '@angular/core';
import {HeaderComponent} from '@app/header/header.component';
import {GoBackDirective} from '@util/directives/go-back.directive';
import {ToolbarComponent} from '@app/toolbar/toolbar.component';

@Component({
  selector: 'app-interview',
  templateUrl: './interview.component.html',
  styleUrls: ['./interview.component.scss'],
  standalone: true,
  imports: [HeaderComponent, GoBackDirective, ToolbarComponent],
})
export class InterviewComponent {}
